export const DEFAULT_PARTNER_CHANNEL_COMMISSIONREATE = {
  app: 15,
  'naver-store': 15,
  'kakao-reservation': 17.5,
  'inbound-app': 15,
  'inbound-naver': 15,
  benepia: 20,
};
